import { colors } from "colors"
import styled from "styled-components"

interface StepUpSectionWrapperProps {
  h2Color?: string
}

export const StepUpSectionWrapper = styled.div<StepUpSectionWrapperProps>`
  padding-bottom: 290px;
  padding-top: 120px;
  display: flex;
  flex-direction: column;
  min-height: 450px;
  justify-content: center;
  align-items: center;
  background: radial-gradient(
    48.75% 74.31% at 46.83% 72.24%,
    ${colors.mainGreen} -50%,
    ${colors.goodBlack} 100%
  );
  div {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 1000px;
    svg {
      margin-bottom: 30px;
    }
    h2 {
      color: ${(props) =>
        props.h2Color && props?.h2Color ? props.h2Color : "white"};
      text-align: center;
      margin-bottom: 30px;
    }
  }

  @media (max-width: 768px) {
    button {
      width: 70%;
    }
  }
`;
